/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessMedicationRenewalResponse } from '../models/SuccessMedicationRenewalResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MedicationRenewalControllerService {

    /**
     * Get the authenticated member's medication renewal of a given type
     * Returns the renewal status, window, identifiers and the requirement checklist
     * @param type
     * @returns SuccessMedicationRenewalResponse Medication renewal retrieved
     * @throws ApiError
     */
    public static getMedicationRenewal(
        type: 'GLP1_WEIGHTLOSS',
    ): CancelablePromise<SuccessMedicationRenewalResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/medication-renewal/{type}',
            path: {
                'type': type,
            },
            errors: {
                400: `Unknown medication renewal type`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `No active renewal of this type for the member`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
